export default "__VITE_ASSET__c8a5047d__"